import type { IconData } from "../types";

/**
 * Generate TypeScript component code
 */
export function generateTypeScriptComponent(icon: IconData): string {
  const { componentName, viewBox, paths } = icon;
  const timestamp = new Date().toISOString();

  return `// Generated by @pyyupsk/pixelarticons CLI - changes may be overwritten
// Generated at: ${timestamp}
// Icon: ${icon.name}

import { SVGProps } from 'react';

export interface ${componentName}Props extends SVGProps<SVGSVGElement> {
  size?: number | string;
}

export function ${componentName}({ size = 24, ...props }: ${componentName}Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="${viewBox}"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>${icon.name}</title>
      ${paths}
    </svg>
  );
}

${componentName}.displayName = '${componentName}';
`;
}

/**
 * Generate JavaScript component code
 */
export function generateJavaScriptComponent(icon: IconData): string {
  const { componentName, viewBox, paths } = icon;
  const timestamp = new Date().toISOString();

  return `// Generated by @pyyupsk/pixelarticons CLI - changes may be overwritten
// Generated at: ${timestamp}
// Icon: ${icon.name}

import React from 'react';

export function ${componentName}({ size = 24, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="${viewBox}"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>${icon.name}</title>
      ${paths}
    </svg>
  );
}

${componentName}.displayName = '${componentName}';
`;
}

/**
 * Generate index file that exports all components
 */
export function generateIndexFile(componentNames: string[]): string {
  const timestamp = new Date().toISOString();

  const exports = componentNames
    .map((name) => `export { ${name} } from './${name}';`)
    .join("\n");

  return `// Generated by @pyyupsk/pixelarticons CLI - changes may be overwritten
// Generated at: ${timestamp}

${exports}
`;
}
